import { render, staticRenderFns } from "./ProductSpecification.vue?vue&type=template&id=3e7a7f78&scoped=true&"
import script from "./ProductSpecification.vue?vue&type=script&lang=js&"
export * from "./ProductSpecification.vue?vue&type=script&lang=js&"
import style0 from "./ProductSpecification.vue?vue&type=style&index=0&id=3e7a7f78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7a7f78",
  null
  
)

export default component.exports